import { NavLink, Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { sectors } from '../pages/sectors/sectorsData';

export default function Nav({ menuOpen, onBurgerClick }) {
  const { isEN, t, toggle } = useLanguage();
  const { pathname } = useLocation();
  const onSector = pathname.startsWith('/sectors');

  return (
    <header className="nav on-dark" data-screen-label={isEN ? 'Home' : 'الرئيسية'}>
      <Link className="brand" to="/" aria-label={isEN ? 'Elhaware Group' : 'مجموعة الهواري'}>
        <span className="brand-logo">
          <img className="brand-logo__white" src="/assets/logo-c.png" alt={isEN ? 'Elhaware Group' : 'مجموعة الهواري'} />
          <img className="brand-logo__color" src="/assets/logo-c.png" alt={isEN ? 'Elhaware Group' : 'مجموعة الهواري'} />
        </span>
        <span className="brand-name">{isEN ? 'Elhaware Group' : 'مجموعة الهواري'}<span>{isEN ? 'ELHAWARE GROUP' : 'EST. 2015'}</span></span>
      </Link>

      <nav className="nav-links" aria-label={isEN ? 'Main navigation' : 'التنقل الرئيسي'}>
        <NavLink className="nav-link" to="/" end>{isEN ? 'Home' : 'الرئيسية'}</NavLink>
        <NavLink className="nav-link" to="/about">{isEN ? 'About' : 'من نحن'}</NavLink>
        <div className="nav-item">
          <span className="nav-link nav-item__toggle" aria-current={onSector ? 'page' : undefined}>
            {isEN ? 'Our Sectors' : 'قطاعاتنا'} <span className="nav-caret">▾</span>
          </span>
          <div className="nav-dropdown">
            {sectors.map((s) => (
              <NavLink key={s.slug} to={s.route}>{t(s.navLabel)}</NavLink>
            ))}
          </div>
        </div>
        <Link className="nav-link" to="/" state={{ scrollTo: 'global' }}>{isEN ? 'Global' : 'الفروع الخارجية'}</Link>
        <NavLink className="nav-link" to="/media">{isEN ? 'Media Center' : 'المركز الإعلامي'}</NavLink>
        <NavLink className="nav-link" to="/contact">{isEN ? 'Contact Us' : 'تواصل معنا'}</NavLink>
      </nav>

      <div className="nav-actions">
        <button className="lang-toggle lang-desktop" type="button" onClick={toggle} aria-label={isEN ? 'Switch language' : 'تبديل اللغة'}>
          <span>{isEN ? 'العربية' : 'EN'}</span>
        </button>
        <button
          className="nav-burger"
          type="button"
          aria-label={isEN ? 'Menu' : 'القائمة'}
          aria-expanded={menuOpen}
          onClick={onBurgerClick}
        >
          <span></span><span></span><span></span>
        </button>
      </div>
    </header>
  );
}
